import React from 'react'

const PrivacyPolicy = () => {
  return (
    <div className="p-4 has-text-centered" style={{ minHeight: '100vh' }}>
      <iframe
        src="https://docs.google.com/document/d/e/2PACX-1vR3w3aWaHwvK098QgKxcDC16ocClWdnOVWDk_TkRapkO3HpsRCVlA7DS9WHwQ7qnbb5vGRd6gUM3LuK/pub?embedded=true"
        title="Privacy Policy"
        width="100%"
        height="1280px"
        style={{ border: 'none' }}
      />
    </div>
  )
}

export default PrivacyPolicy